import script from "./TagManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./TagManagement.vue?vue&type=script&setup=true&lang=js"

import "./TagManagement.vue?vue&type=style&index=0&id=a11c7796&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a11c7796"]])

export default __exports__